import script from "./v-row.vue?vue&type=script&lang=js"
export * from "./v-row.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__